import UniversityProgramsDesk from "./Desk/UniversityProgramsDesk";
import UniversityProgramsMob from "./Mob/UniversityProgramsMob";

const UniversityPrograms = () => {
  return <>{window.innerWidth <= 767 ? <UniversityProgramsMob /> : <UniversityProgramsDesk />}</>;
};

export default UniversityPrograms;
